<script>
  import { createEventDispatcher } from "svelte"

  export let glyph
  export let selected

  const dispatch = createEventDispatcher()

  function handleClick() {
    dispatch("click", {
      glyph: glyph,
    })
  }
</script>

<button on:click={handleClick} class:selected>{glyph.character}</button>

<style lang="scss">
  @use "../../partials";
  button {
    font-family: var(--family);

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    aspect-ratio: 1;

    padding: 0;

    color: inherit;
    background-color: inherit;

    cursor: pointer;

    padding-top: 0.3em;
    padding-bottom: 0.3em;
  }

  button:empty {
    display: none;
  }

  button:hover {
    @include partials.media(">phone") {
      color: var(--main-background-color);
      border-color: var(--main-color);
      background-color: var(--main-color);
    }
  }

  .selected {
    @include partials.media(">phone") {
      color: var(--main-background-color);
      border-color: var(--main-color);
      background-color: var(--main-color);
      outline: 1px solid var(--main-color);
    }
  }
</style>
